module.exports = __webpack_public_path__ + "img/company-5.cffae4c0.png";